/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable one-var */
import loadScript from "simple-load-script";

import { FCM_CONFIG, FIREBASE_VERSION } from "../config";
import { TOKEN_SENT_TO_SERVER } from "./components/constants";
import { setItemForSession, getSessionItem } from "./sessionStorage";

let sendTokenToServer,
	SWRegistration,
	firebaseJsIsLoading = false,
	fcmJsIsDefined = false,
	isLoggedIn = false,
	messaging = null;

const tokenSentToServer = sent => {
	setItemForSession(TOKEN_SENT_TO_SERVER, sent);
};

const _sendTokenToServer = (currentToken, isLoggedIn) => {
	console.log("Saving token...", currentToken);
	const sentToServer = getSessionItem(TOKEN_SENT_TO_SERVER);
	if (isLoggedIn && !sentToServer) {
		sendTokenToServer(currentToken);
		tokenSentToServer(true);
	}
};

const _notify = ({ title, ...options }) =>
	SWRegistration.showNotification(title, {
		...options,
		vibrate: [200, 100, 400]
	});

const _spawnNotification = payload => {
	if (!("Notification" in window)) {
		// Let's check if the browser supports notifications
		console.warn("This browser does not support desktop notification");
	} else if (Notification.permission === "granted") {
		// Let's check whether notification permissions have already been granted
		// If it's okay let's create a notification
		_notify(payload);
	} else if (Notification.permission !== "denied") {
		// Otherwise, we need to ask the user for permission
		Notification.requestPermission(permission => {
			// If the user accepts, let's create a notification
			if (permission === "granted") {
				_notify(payload);
			}
		});
	}
};

const FCMPush = {
	loadFCMScript(reg, profileUpdateFunc, isAuth) {
		SWRegistration = reg;
		sendTokenToServer = profileUpdateFunc;
		isLoggedIn = isAuth;
		if (!window.firebase && !firebaseJsIsLoading) {
			firebaseJsIsLoading = true;

			loadScript({
				url: `https://www.gstatic.com/firebasejs/${FIREBASE_VERSION}/firebase-app.js`,
				inBody: true
			})
				.then(() => {
					firebaseJsIsLoading = false;
					this.initialize();
				})
				.catch(err => {
					firebaseJsIsLoading = false;
					console.warn(err);
				});
		} else if (window.firebase) {
			this.initialize();
		}
	},
	initialize() {
		if (!window.firebase.apps.length) {
			// initialize firebase app
			console.log(
				"-------------------INIT FIREBASE APP-------------------"
			);
			window.firebase.initializeApp(FCM_CONFIG);
		}

		if (!fcmJsIsDefined) {
			loadScript({
				url: `https://www.gstatic.com/firebasejs/${FIREBASE_VERSION}/firebase-messaging.js`,
				inBody: true
			})
				.then(() => {
					fcmJsIsDefined = true;
					this.initializeMessaging();
				})
				.catch(err => {
					console.warn(err);
				});
		} else {
			this.initializeMessaging();
		}
	},
	initializeMessaging() {
		console.log(
			"-------------------INIT FCM CLOUD MESSAGING-------------------"
		);

		function _resetUI() {
			messaging
				.getToken()
				.then(currentToken => {
					if (currentToken) {
						_sendTokenToServer(currentToken, isLoggedIn);
					} else {
						// Show permission request.
						console.log(
							"No Instance ID token available. Request permission to generate one."
						);
					}
				})
				.catch(err => {
					console.warn(
						"An error occurred while retrieving token. ",
						err
					);
				});
		}

		if (messaging) {
			messaging
				.requestPermission()
				.then(() => {
					_resetUI();
				})
				.catch(err => {
					console.log("Unable to get permission to notify.", err);
				});

			return;
		}

		// Retrieve Firebase Messaging object.
		messaging = window.firebase.messaging();
		if (SWRegistration) messaging.useServiceWorker(SWRegistration);

		// grant permission to receive notifications in the browser
		messaging
			.requestPermission()
			.then(() => {
				// Notification permission granted
				// Retrieve an Instance ID token for use with FCM.
				_resetUI();
			})
			.catch(err => {
				console.log("Unable to get permission to notify.", err);
			});

		// Callback fired if Instance ID token is updated.
		messaging.onTokenRefresh(() => {
			messaging
				.getToken()
				.then(refreshedToken => {
					console.log("Token refreshed.");
					tokenSentToServer(false);
					_sendTokenToServer(refreshedToken, isLoggedIn);
					_resetUI();
				})
				.catch(err => {
					console.warn("Unable to retrieve refreshed token ", err);
				});
		});

		// eslint-disable-next-line consistent-return
		messaging.onMessage(payload => {
			console.log("Message received. ", payload);

			if (typeof payload !== "object") {
				return false;
			}

			const { data = {} } = payload;
			const { notification = "{}", ...options } = data;
			const receivedNotification = {
				...options,
				...JSON.parse(notification)
			};

			const { body, title } = receivedNotification;
			if (body && title) {
				_spawnNotification(receivedNotification);
			}
		});
	}
};

export default FCMPush;
